import styles from "../styles/pujaList.module.css";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingCircle from "../../globalModule/components/loadingCircle";
import PujaItem from "./pujaItem";
import { Typography } from "@mui/material";
const PujaList = ({
  pujas,
  updateData,
  hasMore
}) => {
  return <>
      {pujas?.benefitData && <div className={styles.pujaBenefitHeader}>
          <h1 className={styles.pujaBenefitHeaderText}>
            {pujas?.benefitData?.benefitName}
          </h1>
          <Typography>{pujas?.benefitData?.benefitDescription}</Typography>
        </div>}
      <InfiniteScroll dataLength={pujas?.length || 0} next={updateData} hasMore={hasMore} loader={pujas?.length < 10 ? "" : <LoadingCircle />} data-sentry-element="InfiniteScroll" data-sentry-source-file="pujaList.jsx">
        <div className={styles.pujasListContainer}>
          {pujas?.eventsData ? pujas?.eventsData?.map((data, index) => <PujaItem key={index} index={index} data={data} />) : pujas?.map((data, index) => <PujaItem key={index} index={index} data={data} />)}
        </div>
      </InfiniteScroll>
    </>;
};
export default PujaList;